import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import prevButtonWhite from "../../img/Markets/prev-w.svg";
import nextButtonWhite from "../../img/Markets/next-w.svg";
import tabForex from "../../img/Markets/tab-forex.webp";
import tabIndices from "../../img/Markets/tab-indices.webp";
import tabCrypto from "../../img/Markets/tab-crypto.webp";
import tabMetals from "../../img/Markets/tab-metals.webp";
import tabCommodities from "../../img/Markets/tab-commodities.webp";
import tabStocks from "../../img/Markets/tab-stocks.webp";
import Fade from 'react-reveal/Fade';

const tabs = [
  {
    id: "forex",
    labelKey: "markets.trade.tabs.forex",
    titleKey: "markets.trade.forex.title",
    descKey: "markets.trade.forex.desc",
    advLabelKey: "markets.trade.forex.advantages.label",
    advantages: [
      "markets.trade.forex.adv.1",
      "markets.trade.forex.adv.2",
      "markets.trade.forex.adv.3",
      "markets.trade.forex.adv.4",
      "markets.trade.forex.adv.5",
      "markets.trade.forex.adv.6",
    ],
    pairs: [
      "markets.trade.forex.pairs.1",
      "markets.trade.forex.pairs.2",
      "markets.trade.forex.pairs.3",
      "markets.trade.forex.pairs.4",
    ],
    image: tabForex,
  },
  {
    id: "indices",
    labelKey: "markets.trade.tabs.indices",
    titleKey: "markets.trade.indices.title",
    descKey: "markets.trade.indices.desc",
    advLabelKey: "markets.trade.indices.advantages.label",
    advantages: [
      "markets.trade.indices.adv.1",
      "markets.trade.indices.adv.2",
      "markets.trade.indices.adv.3",
      "markets.trade.indices.adv.4",
      "markets.trade.indices.adv.5",
      "markets.trade.indices.adv.6",
    ],
    pairs: [
      "markets.trade.indices.pairs.1",
      "markets.trade.indices.pairs.2",
      "markets.trade.indices.pairs.3",
      "markets.trade.indices.pairs.4",
      "markets.trade.indices.pairs.5",
    ],
    image: tabIndices,
  },
  {
    id: "crypto",
    labelKey: "markets.trade.tabs.crypto",
    titleKey: "markets.trade.crypto.title",
    descKey: "markets.trade.crypto.desc",
    advLabelKey: "markets.trade.crypto.advantages.label",
    advantages: [
      "markets.trade.crypto.adv.1",
      "markets.trade.crypto.adv.2",
      "markets.trade.crypto.adv.3",
      "markets.trade.crypto.adv.4",
      "markets.trade.crypto.adv.5",
      "markets.trade.crypto.adv.6",
    ],
    pairs: [
      "markets.trade.crypto.pairs.1",
      "markets.trade.crypto.pairs.2",
      "markets.trade.crypto.pairs.3",
      "markets.trade.crypto.pairs.4",
    ],
    image: tabCrypto,
  },
  {
    id: "metals",
    labelKey: "markets.trade.tabs.metals",
    titleKey: "markets.trade.metals.title",
    descKey: "markets.trade.metals.desc",
    advLabelKey: "markets.trade.metals.advantages.label",
    advantages: [
      "markets.trade.metals.adv.1",
      "markets.trade.metals.adv.2",
      "markets.trade.metals.adv.3",
      "markets.trade.metals.adv.4",
      "markets.trade.metals.adv.5",
      "markets.trade.metals.adv.6",
    ],
    pairs: [
      "markets.trade.metals.pairs.1",
      "markets.trade.metals.pairs.2",
    ],
    image: tabMetals,
  },
  {
    id: "commodities",
    labelKey: "markets.trade.tabs.commodities",
    titleKey: "markets.trade.commodities.title",
    descKey: "markets.trade.commodities.desc",
    advLabelKey: "markets.trade.commodities.advantages.label",
    advantages: [
      "markets.trade.commodities.adv.1",
      "markets.trade.commodities.adv.2",
      "markets.trade.commodities.adv.3",
      "markets.trade.commodities.adv.4",
      "markets.trade.commodities.adv.5",
      "markets.trade.commodities.adv.6",
    ],
    pairs: [
      "markets.trade.commodities.pairs.1",
      "markets.trade.commodities.pairs.2",
      "markets.trade.commodities.pairs.3",
    ],
    image: tabCommodities,
  },
  {
    id: "stocks",
    labelKey: "markets.trade.tabs.stocks",
    titleKey: "markets.trade.stocks.title",
    descKey: "markets.trade.stocks.desc",
    advLabelKey: "markets.trade.stocks.advantages.label",
    advantages: [
      "markets.trade.stocks.adv.1",
      "markets.trade.stocks.adv.2",
      "markets.trade.stocks.adv.3",
      "markets.trade.stocks.adv.4",
      "markets.trade.stocks.adv.5",
      "markets.trade.stocks.adv.6",
      "markets.trade.stocks.adv.7",
    ],
    pairs: [
      "markets.trade.stocks.pairs.1",
      "markets.trade.stocks.pairs.2",
      "markets.trade.stocks.pairs.3",
      "markets.trade.stocks.pairs.4",
    ],
    image: tabStocks,
  },
];

function TradeAssets() {
  const { t, i18n } = useTranslation();
  const isDE = i18n.language === "de";
  const isPL = i18n.language === "pl";
  const [activeIdx, setActiveIdx] = useState(0);

  const active = tabs[activeIdx];

  const handlePrev = () => setActiveIdx((i) => (i === 0 ? tabs.length - 1 : i - 1));
  const handleNext = () => setActiveIdx((i) => (i === tabs.length - 1 ? 0 : i + 1));

  return (
    <section className="mt-[80px] xl:mt-[160px] bg-[#05193a]">
      {/* Desktop */}
      <div className="hidden xl:block">
        <div className={`relative mx-auto max-w-[1220px] overflow-hidden ${isPL ? "h-[800px]" : isDE ? "h-[750px]" : "h-[674px]"}`}>
          {/* Left content */}
          <Fade bottom>
          <div className="absolute left-0 top-[50px] w-[580px]">
            <h2 className="font-['Nunito_Sans'] text-[32px] font-black leading-[1.5] text-[#daebfc]">
              {t("markets.trade.sectionTitle")}
            </h2>
            <span className="mt-[8px] block h-[4px] w-[104px] bg-white opacity-40" />

            <div
              key={active.id}
              className="mt-[20px] flex animate-[offer-image-in_500ms_ease-out] flex-col gap-[20px]"
            >
              <p className="font-['Nunito_Sans'] text-[21px] font-black leading-[1.5] text-white">
                {t(active.titleKey)}
              </p>
              <p className="max-w-[521px] font-['Nunito_Sans'] text-[16px] font-light leading-[1.5] text-white">
                {t(active.descKey)}
              </p>
              <p className="font-['Nunito_Sans'] text-[16px] font-bold leading-[1.5] text-white">
                {t(active.advLabelKey)}
              </p>
              <div className="flex flex-wrap gap-[12px]">
                {active.advantages.map((key) => (
                  <span
                    key={key}
                    className="rounded-[12px] border border-[rgba(255,255,255,0.15)] px-[12px] py-[4px] font-['Nunito_Sans'] text-[16px] font-light text-white"
                  >
                    {t(key)}
                  </span>
                ))}
              </div>
              <div className="flex flex-wrap gap-[12px]">
                {active.pairs.map((key) => (
                  <span
                    key={key}
                    className="rounded-[12px] border border-[rgba(255,255,255,0.15)] bg-[rgba(218,235,252,0.15)] px-[12px] py-[4px] font-['Nunito_Sans'] text-[16px] font-light text-white"
                  >
                    {t(key)}
                  </span>
                ))}
              </div>
            </div>
          </div>

          </Fade>

          {/* Right image */}
          <div className={`absolute right-0 top-0 w-[592px] overflow-hidden ${isPL ? "h-[800px]" : isDE ? "h-[750px]" : "h-[674px]"}`}>
            <img
              key={active.id}
              src={active.image}
              alt=""
              className="h-full w-full animate-[offer-image-in_500ms_ease-out] object-cover"
            />
          </div>

          {/* Pagination */}
          <div className="absolute bottom-[48px] left-0 flex items-center gap-[10px]">
            {tabs.map((tab, i) => (
              <button
                key={tab.id}
                type="button"
                aria-label={t(tab.labelKey)}
                onClick={() => setActiveIdx(i)}
                className={`h-[2px] w-[42px] transition-colors ${
                  i === activeIdx ? "bg-white" : "bg-[rgba(255,255,255,0.24)]"
                }`}
              />
            ))}
          </div>

          {/* Arrows */}
          <div className="absolute bottom-[34px] left-[344px] flex gap-[15px]">
            <button type="button" aria-label="Previous" onClick={handlePrev}>
              <img src={prevButtonWhite} alt="" className="h-[42px] w-[42px]" />
            </button>
            <button type="button" aria-label="Next" onClick={handleNext}>
              <img src={nextButtonWhite} alt="" className="h-[42px] w-[42px]" />
            </button>
          </div>

          {/* Tab pills */}
          <div className="absolute bottom-[96px] w-[572px] right-0 flex flex-wrap gap-[12px]">
            {tabs.map((tab, i) => (
              <button
                key={tab.id}
                type="button"
                onClick={() => setActiveIdx(i)}
                className={`rounded-[12px] px-[12px] py-[4px] font-['Nunito_Sans'] text-[16px] font-light transition-colors ${
                  i === activeIdx
                    ? "border border-white bg-[#05193a] text-white"
                    : "bg-[#daebfc] text-[#05193a]"
                }`}
              >
                {t(tab.labelKey)}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Mobile */}
      <div className="xl:hidden">
        {/* Tab pills */}
        <Fade bottom>
        <div className="flex flex-wrap gap-[12px] justify-center px-[20px] pt-[30px]">
          {tabs.map((tab, i) => (
            <button
              key={tab.id}
              type="button"
              onClick={() => setActiveIdx(i)}
              className={`rounded-[60px] px-[15px] py-[6px] font-['Nunito_Sans'] text-[14px] transition-colors ${
                i === activeIdx
                  ? "bg-[#eaf4ff] text-[#05193a]"
                  : "border border-[rgba(255,255,255,0.5)] text-white"
              }`}
            >
              {t(tab.labelKey)}
            </button>
          ))}
        </div>

        </Fade>

        {/* Content */}
        <Fade bottom delay={150}>
        <div className="px-[20px] mt-[30px] pb-[40px] flex flex-col gap-[20px]">
          <h2 className="font-['Nunito_Sans'] text-[26px] font-black leading-[1.5] text-[#daebfc]">
            {t("markets.trade.sectionTitle")}
          </h2>
          <span className="block h-[4px] w-[104px] bg-white opacity-40" />
          <p className="font-['Nunito_Sans'] text-[18px] font-black leading-[1.5] text-white">
            {t(active.titleKey)}
          </p>
          <p className="font-['Nunito_Sans'] text-[14px] font-light leading-[1.5] text-white">
            {t(active.descKey)}
          </p>
          <p className="font-['Nunito_Sans'] text-[14px] font-bold leading-[1.5] text-white">
            {t(active.advLabelKey)}
          </p>
          <div className="flex flex-wrap gap-[12px]">
            {active.advantages.map((key) => (
              <span
                key={key}
                className="border border-[rgba(255,255,255,0.15)] rounded-[12px] px-[8px] py-[2px] font-['Nunito_Sans'] text-[14px] font-light text-white"
              >
                {t(key)}
              </span>
            ))}
          </div>
          <div className="flex flex-wrap gap-[12px]">
            {active.pairs.map((key) => (
              <span
                key={key}
                className="bg-[rgba(218,235,252,0.15)] border border-[rgba(255,255,255,0.15)] rounded-[12px] px-[8px] py-[2px] font-['Nunito_Sans'] text-[14px] font-light text-white"
              >
                {t(key)}
              </span>
            ))}
          </div>
        </div>
        </Fade>
      </div>
    </section>
  );
}

export default TradeAssets;
